<template>
    <v-app id="inspire">
        <v-app-bar app dark color="primary">
            <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->
            <v-img src="/logo_full_dark.png" alt="Lundoch" max-height="48px" max-width="170px" contain />

            <v-divider vertical class="ms-3" />

            <v-app-bar-title>
                {{ VITE_APP_TITLE }}
            </v-app-bar-title>

            <v-spacer />

            <template v-if="isAuthenticated">
                <div class="text-body-1">
                    {{ auth0user?.name }}
                </div>
                <v-divider vertical class="ms-3" />
                <LogoutButton />
            </template>
            <template v-else>
                <LoginButton />
            </template>
        </v-app-bar>

        <!--
        <v-navigation-drawer app v-model="drawer">
        </v-navigation-drawer>
        -->

        <v-main>
            <v-container v-if="isAuthenticated">
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="8">
                        <v-sheet min-height="70vh" rounded="lg">
                            <BatchUploadForm v-if="isBatch" />
                            <UploadForm v-else />
                            <Pinger v-if="VITE_APP_PING_ENABLED" />
                        </v-sheet>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script setup lang="ts">
import LoginButton from "@/components/buttons/login-button.vue";
import LogoutButton from "@/components/buttons/logout-button.vue";
import UploadForm from "@/components/upload-form.vue";
import BatchUploadForm from "@/components/batch-upload-form.vue";
import Pinger from "@/components/pinger.vue";
import { useAuth0 } from "@auth0/auth0-vue";

const { user, isAuthenticated } = useAuth0();
const { VITE_APP_TITLE, VITE_APP_PING_ENABLED } = import.meta.env;

import { ref, computed } from "vue";

const auth0user = ref(user);

const isBatch = computed(() => {
    if (!auth0user.value) {
        return false;
    }

    const namespace = "https://lundochdiagnostics.com";

    let roles = auth0user?.value[`${namespace}/roles`] || [];

    return roles.includes("batch");
});


//const drawer = ref<boolean>(false);

</script>
